// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2DZ2Y","balanceDisclaimer":"posDashboard_balanceDisclaimer__3czPy"};